'use strict';

/**
 * View for a single species in edit/create dialog
 *
 * @category   View
 * @module     collectio.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoCollection = require('base/Colido.Collection');
var ColidoModel = require('base/Colido.Model');
var LayoutView = require('base/Colido.LayoutView');
var SpeciesSelectionListView = require('./field-species-list');

var template = require('../../templates/components/field-species.hbs');

var SpeciesComponent = LayoutView.extend({
    template: template,

    className: function() {
        var field = this.getOption('field');

        return 'form-component component-' + _.camelToHyphen(field.type);
    },

    regions: {
        speciesListRegion: '#subregion-additional-species',
    },

    /**
     * Collection for the species
     * @type {ColidoCollection}
     */
    speciesCollection: null,

    viewData: {
        field: function() {
            return this.getOption('field');
        },
    },

    initialize: function(options) {
        LayoutView.prototype.initialize.apply(this, arguments);

        var field = this.getOption('field');

        this.speciesCollection = new ColidoCollection();

        this.listenTo(this.speciesCollection, 'change:name', this.onSpeciesNameChanged.bind(this));
        this.listenTo(this.speciesCollection, 'remove', this.onSpeciesRemoved.bind(this));

        // Add existing species
        var species = this.model.get(field.name);

        if (species.length > 0) {
            _.each(species, function(speciesModel, index) {
                var correlation = _.has(speciesModel, 'correlation') ? speciesModel.correlation : null;
                this.addSpecies(index, speciesModel.name, correlation);
            }.bind(this));
        } else { // Add empty species if no species exist yet
            this.addSpecies(0);
        }

        this.addSpecies(this.speciesCollection.length);
    },

    onSpeciesNameChanged: function(model) {
        var index = this.speciesCollection.indexOf(model);
        var remove = model.get('name').length === 0 && index > 0;

        if (remove) {
            model.set('active', false);
            _.delay(function () {
                this.speciesCollection.remove(model);
            }.bind(this), 400);
        } else {
            if (index === this.speciesCollection.length - 1) { // The last species was changed
                this.addSpecies(this.speciesCollection.length);
            }
        }
    },

    /**
     * Is triggered from collection, when a species has been removed
     */
    onSpeciesRemoved: function() {
        // Rebuild index of species
        this.speciesCollection.each(function(model, index) {
            model.set('index', index);
        }.bind(this));
    },

    onRender: function() {
        var speciesCollectionListView = new SpeciesSelectionListView({
            collection: this.speciesCollection,
        });

        this.speciesListRegion.show(speciesCollectionListView);
    },

    /**
     * Adds a new species to the internal collection
     * @param {number} idx              Index of the species
     * @param {string=} name            Name of the species
     * @param {string=} correlation     Correlation of the species
     */
    addSpecies: function(index, name, correlation) {
        this.speciesCollection.add(new ColidoModel({
            index: index,
            name: name || '',
            correlation: correlation || 'comma',
            active: true,
        }));
    },

    //@todo switch saving of known species to IDs
    getData: function(defaults) {
        var data = {};
        var field = this.getOption('field');

        var species = [];

        this.speciesCollection.each(function(model, index) {
            var speciesString = model.get('name').trim();

            if (speciesString.length > 0) {
                var speciesObject = {};
                var speciesId = parseInt(speciesString, 10);

                if (_.isNumber(speciesId) && !_.isNaN(speciesId)) {
                    speciesObject.id = speciesId;
                } else {
                    speciesObject.name =  speciesString;
                }

                if (species.length > 0) {
                    speciesObject.correlation = model.get('correlation');
                }

                species.push(speciesObject);
            }
        }.bind(this));

        data[field.name] = species;

        return data;
    },
});

module.exports = SpeciesComponent;